import { serviceBase } from "../service";

const Medium = {
  resource: "",
  preList: "mediums",
  getList: serviceBase.getList,
  getPreList: serviceBase.getPreList,
  preListOption: serviceBase.preListOption
};

export default Medium;
